"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./../UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Rozhraní pro práci s geodaty. Generated from cz.marbes.api.objekt.v1.DescriptionService.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-06-17T17:59:53Z                      #

// ##############################################################

var DescriptionApi = function () {
  function DescriptionApi() {
    (0, _classCallCheck3.default)(this, DescriptionApi);
  }

  (0, _createClass3.default)(DescriptionApi, null, [{
    key: "describeGeometry",

    /**
     * Vrátí popis GeoJSON objektu.
     *
     * @param geo 
     * @return popis GeoJSON objektu
     */
    value: function describeGeometry(geo) {
      var uri = serverContextPath + "/api/objekt/v1/description/describeGeo";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, geo, headers));
    }
  }]);
  return DescriptionApi;
}();

exports.default = DescriptionApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvYXBpL2dlbi9leHRPYmpla3R5L3YxL0Rlc2NyaXB0aW9uQXBpLmpzeCJdLCJuYW1lcyI6WyJVcGRhdGVNZXRob2RzIiwiRGVzY3JpcHRpb25BcGkiLCJnZW8iLCJ1cmkiLCJzZXJ2ZXJDb250ZXh0UGF0aCIsImhlYWRlcnMiLCJ1bmRlZmluZWQiLCJwYXJhbXMiLCJFcnJvckFwaSIsInJlc3BvbnNlUmVzb2x2ZXIiLCJKc29uRmV0Y2giLCJwb3N0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7OztBQVFBOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFFQTs7SUFBWUEsYTs7Ozs7O0FBRVo7OztBQWhCQTs7QUFFQTs7QUFFQTs7QUFFQTs7SUFhcUJDLGM7Ozs7Ozs7O0FBQ2pCOzs7Ozs7cUNBTXdCQyxHLEVBQUs7QUFDekIsVUFBTUMsTUFBTUMsNERBQVo7QUFDQSxVQUFNQyxVQUFVQyxTQUFoQjtBQUNBLFVBQU1DLFNBQVMsRUFBZjs7QUFFQSxhQUFPQyxtQkFBU0MsZ0JBQVQsQ0FBMEJDLG9CQUFVQyxJQUFWLENBQWVSLEdBQWYsRUFBb0JJLE1BQXBCLEVBQTRCTCxHQUE1QixFQUFpQ0csT0FBakMsQ0FBMUIsQ0FBUDtBQUNIOzs7OztrQkFiZ0JKLGMiLCJmaWxlIjoiRGVzY3JpcHRpb25BcGkuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyAjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjI1xuXG4vLyAjICAgICAgICAgICAgIEdFTkVST1ZBTsOdIEvDk0QsIE5FTU9ESUZJS09WQVQhISEhICAgICAgICAgICAgICAjXG5cbi8vICMgICAgICAgICAgICAgICAgICAyMDI1LTA2LTE3VDE3OjU5OjUzWiAgICAgICAgICAgICAgICAgICAgICAjXG5cbi8vICMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjXG5cbmltcG9ydCBFcnJvckFwaSBmcm9tIFwiLi8uLi8uLi8uLi8uLi91dGlscy9FcnJvckFwaVwiO1xuaW1wb3J0IEZldGNoIGZyb20gXCIuLy4uLy4uLy4uLy4uL3V0aWxzL0ZldGNoXCI7XG5pbXBvcnQgUGFyYW1zRmV0Y2ggZnJvbSBcIi4vLi4vLi4vLi4vLi4vdXRpbHMvUGFyYW1zRmV0Y2hcIjtcbmltcG9ydCBKc29uRmV0Y2ggZnJvbSBcIi4vLi4vLi4vLi4vLi4vdXRpbHMvSnNvbkZldGNoXCI7XG5pbXBvcnQgZ2VuZXJhdGVVcmwgZnJvbSAnLi8uLi8uLi8uLi8uLi91dGlscy9nZW5lcmF0ZVVybCc7XG5cbmltcG9ydCAqIGFzIFVwZGF0ZU1ldGhvZHMgZnJvbSBcIi4vLi4vVXBkYXRlTWV0aG9kc1wiO1xuXG4vKipcbiAqIFJvemhyYW7DrSBwcm8gcHLDoWNpIHMgZ2VvZGF0eS4gR2VuZXJhdGVkIGZyb20gY3oubWFyYmVzLmFwaS5vYmpla3QudjEuRGVzY3JpcHRpb25TZXJ2aWNlLlxuICovXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBEZXNjcmlwdGlvbkFwaSB7XG4gICAgLyoqXG4gICAgICogVnLDoXTDrSBwb3BpcyBHZW9KU09OIG9iamVrdHUuXG4gICAgICpcbiAgICAgKiBAcGFyYW0gZ2VvIFxuICAgICAqIEByZXR1cm4gcG9waXMgR2VvSlNPTiBvYmpla3R1XG4gICAgICovXG4gICAgc3RhdGljIGRlc2NyaWJlR2VvbWV0cnkoZ2VvKSB7XG4gICAgICAgIGNvbnN0IHVyaSA9IHNlcnZlckNvbnRleHRQYXRoICsgYC9hcGkvb2JqZWt0L3YxL2Rlc2NyaXB0aW9uL2Rlc2NyaWJlR2VvYDtcbiAgICAgICAgY29uc3QgaGVhZGVycyA9IHVuZGVmaW5lZDtcbiAgICAgICAgY29uc3QgcGFyYW1zID0geyAgfTtcbiAgICAgICAgIFxuICAgICAgICByZXR1cm4gRXJyb3JBcGkucmVzcG9uc2VSZXNvbHZlcihKc29uRmV0Y2gucG9zdCh1cmksIHBhcmFtcywgZ2VvLCBoZWFkZXJzKSk7XG4gICAgfVxuXG59Il19